<template>
<el-dialog title="修改个人资料" :visible.sync="visible" width="35%" :before-close="beforeClose">
    <el-form ref="form" :model="iform" label-width="80px">
        <el-form-item label="昵称：">
            <el-input v-model="iform.uname"></el-input>
        </el-form-item>
        <el-form-item label="性别：">
            <el-radio-group v-model="iform.sex">
                <el-radio label="男" value="1"></el-radio>
                <el-radio label="女" value="2"></el-radio>
            </el-radio-group>
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
    </div>
</el-dialog>
</template>

<script>
import Y from '@/utils/Y'

export default {
    props: {
    },
    data() {
        return {
            visible: false,
            iform: {
                uname: '赵晓费',
                sex: 1
            }
        }
    },
    components: {},
    methods:{
        
        onSubmit () {

        },

        /**
         * 开启窗口
        */
        open () {
            this.visible = true
        },

        /**
         * 关闭窗口
        */
        close () {
            this.visible = false
        },

        // 关闭窗口
        beforeClose (done) {
            done()
        }
    }
}
</script>

<style lang="less" scoped>
</style>